module.exports = __webpack_public_path__ + "img/shopping-cart_sale.1b834f7b.png";